import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: '01',
  title: 'Guiones de WhatsApp para Situaciones Difíciles',
  desc: '20 guiones listos para copiar y pegar en WhatsApp Business para las situaciones más incómodas: pedidos de descuento, consultas fuera de horario, documentación tardía, clientes que regatean. Nunca más quedarte sin palabras.',
  value: '$8.000'
}, {
  num: '02',
  title: 'Calculadora de Honorarios PRO',
  desc: 'Planilla Excel con fórmulas para calcular tu honorario real por hora, el impacto de la inflación en tus abonos y la proyección de ingresos con el nuevo Menú de 3 Niveles. Completás tus números y te dice exactamente cuánto cobrar.',
  value: '$9.000'
}, {
  num: '03',
  title: 'Biblioteca de Prompts ARCA Express',
  desc: 'Los 10 prompts más usados para circulares, requerimientos y VEPs listos en una sola hoja de referencia rápida. Imprimible. Para tener al lado del teclado.',
  value: '$8.000'
}, {
  num: '04',
  title: 'Plantillas de Mail Profesional',
  desc: '15 mails listos para las situaciones más frecuentes: aumento de honorarios, comunicación de vencimientos, solicitud de documentación, respuesta a requerimientos y más. Solo cambiás el nombre y enviás.',
  value: '$10.000'
}];
export function Bonuses() {
  return <section className="py-20 bg-brand-darker border-y border-slate-800/50" data-id="element-16">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-17">
        <FadeIn className="text-center mb-16" data-id="element-18">
          <div className="inline-flex items-center justify-center p-4 bg-brand-accent/10 rounded-full mb-6" data-id="element-19">
            <Gift className="w-10 h-10 text-brand-accent" data-id="element-20" />
          </div>
          <h2 className="text-4xl font-bold mb-4" data-id="element-21">🎁 4 BONOS ESTRATÉGICOS</h2>
          <p className="text-xl text-brand-accent font-bold uppercase tracking-wider" data-id="element-22">
            Siempre Incluidos
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-23">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-24">
              <div className="bg-brand-card border border-slate-700 hover:border-brand-accent/50 transition-colors p-6 rounded-2xl h-full flex flex-col relative overflow-hidden group" data-id="element-25">
                <div className="absolute top-0 right-0 w-32 h-32 bg-brand-accent/5 rounded-bl-full -z-10 group-hover:bg-brand-accent/10 transition-colors" data-id="element-26" />

                <div className="flex items-center gap-3 mb-4" data-id="element-27">
                  <span className="text-sm font-bold text-slate-500 bg-slate-800 px-2 py-1 rounded" data-id="element-28">
                    BONO {bonus.num}
                  </span>
                  <h3 className="text-xl font-bold text-white leading-tight" data-id="element-29">
                    {bonus.title}
                  </h3>
                </div>

                <p className="text-slate-300 text-sm mb-6 flex-grow" data-id="element-30">
                  {bonus.desc}
                </p>

                <div className="mt-auto pt-4 border-t border-slate-800 flex items-center justify-between" data-id="element-31">
                  <span className="text-slate-500 line-through text-sm" data-id="element-32">
                    Valor: {bonus.value}
                  </span>
                  <span className="text-brand-accent font-bold" data-id="element-33">→ GRATIS</span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}